import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center gap-3 w-full animate-slideFadeIn" }
const _hoisted_2 = { class: "flex justify-end text-sm w-full px-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-red-600 bg-red-100 px-3 py-2 rounded-lg w-full"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "text-center text-sm text-gray-500" }

import { computed, ref } from "vue"
import FormInput from "./FormInput.vue"
import * as Yup from 'yup'
import { useField, useForm } from 'vee-validate';
import { useI18n } from "vue-i18n";
import axios from "@/services/api";
import mixpanel from "../../plugins/mixpanel";
import { useStore } from "vuex";
import { getConfigValue } from "@/core/config";
import { LoaderCircle } from "lucide-vue-next";

import { useRouter } from "vue-router"

export default /*@__PURE__*/_defineComponent({
  __name: 'SignInForm',
  setup(__props) {

const router = useRouter()

const { t } = useI18n();
const store = useStore();
const selectedLanguage = computed(() => store.state.stepper.selectedLanguage);

const isLoading = ref(false)
const errorMessage = ref('')

const schema = Yup.object({
    email: Yup.string()
        .required(() => t("logIn.emailRequired"))
        .email(() => t("logIn.emailValidation")),

    password: Yup.string()
        .min(6, () => t("logIn.passwordValidation"))
        .required(() => t("logIn.passwordRequired")),
})

const { handleSubmit } = useForm({
    validationSchema: schema,
})
const {
    value: email,
    errorMessage: emailError,
    meta: emailMeta,
} = useField<string>("email")

const {
    value: password,
    errorMessage: passwordError,
    meta: passwordMeta,
} = useField<string>("password")

const onSubmit = handleSubmit(async (values) => {

    isLoading.value = true;
    axios
        .post("user/signin", { ...values, selectedLanguage: selectedLanguage.value })
        .then((res) => {
            if (res.status === 200) {
                const loginData = res.data.data
                let user = loginData.user;
                user.accessToken = loginData.token;
                setTimeout(() => {
                    if (process.env.VUE_APP_NODE_ENV === "production") {
                        mixpanel.track('[LOGIN-PAGE] Login', {
                            label: '[LOGIN-PAGE] Login',
                            page: window.location.pathname
                        });
                    }
                    isLoading.value = false;
                    const redirectUrl = loginData?.redirectionUrl || `${getConfigValue('DASHBOARD_DOMAINE')}?token=${loginData.token}?selectedLanguage=${loginData.selectedLanguage}`
                    window.location.href = redirectUrl;
                }, 500)
            }
        })
        .catch((e) => {
            const res = e.response;
            res.data.messages.forEach(
                (msg: { code: number; message: string; metas: any }) => {
                    if (msg.code === 103) {
                        errorMessage.value = msg.message;
                    } else if (msg.code === 104) {
                        errorMessage.value = msg.message;
                    } else if (msg.code === 105) {
                        errorMessage.value = msg.message;
                    } else if (msg.code === 107) {
                        errorMessage.value = msg.message;
                    }
                }
            );

            isLoading.value = false;
        });

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-3xl font-semibold text-gray-600 text-center pb-12" }, " Welcome back 👋 ", -1)),
    _createVNode(FormInput, {
      label: "Email",
      modelValue: _unref(email),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
      type: "email",
      placeholder: "Enter your email address",
      error: _unref(emailMeta).touched ? _unref(emailError) : ''
    }, null, 8, ["modelValue", "error"]),
    _createVNode(FormInput, {
      modelValue: _unref(password),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
      type: "password",
      placeholder: "Enter your password",
      error: _unref(passwordMeta).touched ? _unref(passwordError) : ''
    }, null, 8, ["modelValue", "error"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "text-gray-500 font-medium hover:underline",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/auth/forgot')))
      }, " Forgot password? ")
    ]),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      disabled: isLoading.value,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
      class: "w-full mt-3 text-lg bg-gradient-to-r from-purple-500 to-pink-400 text-white font-semibold py-2.5 rounded-xl flex flex-row items-center justify-center gap-2 hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
    }, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
            key: 0,
            class: "w-4 h-4 animate-spin"
          }))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(isLoading.value ? 'Signing in' : 'Sign in'), 1)
    ], 8, _hoisted_4),
    _createElementVNode("p", _hoisted_5, [
      _cache[5] || (_cache[5] = _createTextVNode(" Don’t have an account? ", -1)),
      _createElementVNode("button", {
        class: "text-purple-500 font-semibold hover:underline ml-1",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/auth/choose')))
      }, " Sign up ")
    ])
  ]))
}
}

})